import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircleFilled, ErrorCircleFilled } from '@ori-ui/icons';
import { Typography, styled } from '@ori-ui/mui';
import { useEffect } from 'react';
import { Localization } from '../../Localization';
import { TranslationKey } from '../../models';
var IconWrapper = styled('div')(function(param) {
    var theme = param.theme;
    return {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginTop: theme.spacing(1),
        '& svg': {
            fontSize: '20px'
        }
    };
});
var CheckIcon = styled(CheckCircleFilled)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.default.light,
        marginRight: theme.spacing(1)
    };
});
var CheckIconSuccess = styled(CheckCircleFilled)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.primary.dark,
        marginRight: theme.spacing(1)
    };
});
var ErrorIcon = styled(ErrorCircleFilled)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.error.dark,
        marginRight: theme.spacing(1)
    };
});
var StyledLabel = styled(Typography)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.default.main
    };
});
var getValidationIcon = function(requirementProperty, value) {
    return requirementProperty.validationRegex.test(value !== null && value !== void 0 ? value : '') ? /*#__PURE__*/ _jsx(CheckIconSuccess, {}) : /*#__PURE__*/ _jsx(ErrorIcon, {});
};
export var PasswordRequirements = function(props) {
    var requirements = props.requirements, minChar = props.minChar, actualValue = props.actualValue, validating = props.validating, setIsValid = props.setIsValid;
    useEffect(function() {
        var allRequirementsMet = requirements.every(function(requirement) {
            return requirement.validationRegex.test(actualValue);
        });
        var minCharRequirementMet = actualValue ? actualValue.length >= minChar : false;
        if (setIsValid) {
            setIsValid(validating ? allRequirementsMet && minCharRequirementMet : false);
        }
    }, [
        validating,
        requirements,
        actualValue,
        minChar,
        setIsValid
    ]);
    return /*#__PURE__*/ _jsx("div", {
        children: requirements.map(function(requirement) {
            return /*#__PURE__*/ _jsxs(IconWrapper, {
                children: [
                    validating ? getValidationIcon(requirement, actualValue) : /*#__PURE__*/ _jsx(CheckIcon, {}),
                    /*#__PURE__*/ _jsx(StyledLabel, {
                        variant: "caption",
                        children: /*#__PURE__*/ _jsx(Localization, {
                            defaultMessage: TranslationKey[requirement.key],
                            id: TranslationKey[requirement.key],
                            values: {
                                min: minChar
                            }
                        })
                    })
                ]
            }, requirement.key);
        })
    });
};
